export default function addI18n(editor) {
  editor.editorManager.i18n.add('zh_CN', {
    Blockquote: '引用',
  })
}
